const AddNewIcon = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9923 28.42V26.34H30.0123V28.42H19.9923ZM23.8123 32.18V22.48H26.1723V32.18H23.8123Z"
        fill="white"
      />
      <path
        d="M31.25 45.8337H18.75C8.33329 45.8337 4.16663 41.667 4.16663 31.2503V18.7503C4.16663 8.33366 8.33329 4.16699 18.75 4.16699H31.25C41.6666 4.16699 45.8333 8.33366 45.8333 18.7503V31.2503C45.8333 41.667 41.6666 45.8337 31.25 45.8337Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { AddNewIcon };
